const styles = () => ({
    container: {
        height: 'auto',
        padding: '1em 2em 2em 2em',
    },
    crc: {
        width: '300px',
        margin: '30px auto 0',
        boxShadow: '0px 15px 45px rgba(0, 0, 0, .2)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'uppercase',
        color: '#666',
        '& h3': {
            margin: '0',
        },
        '& h4': {
            margin: '0',
            fontSize: '.8em',
        },
        cursor: 'pointer',
    },
    iconCrc: {
        borderRadius: '50%',
        width: '50px',
        height: '50px',
        backgroundColor: '#D5DCE8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#23659E',
        margin: '20px',
    },
    infosCrc: {},
    centerProgress: {
        textAlign: 'center',
    },
});

export default styles;
